import * as React from 'react';
import {observer} from 'mobx-react';
import {UIState} from "data/UIState";
import {NavAvatar} from "components/nav/NavAvatar";
import {PageEnums} from "components/nav/PageEnums";
import {WellnessConceptsLogo} from "components/widgets/WellnessConceptsLogo";
import {ManagerPill} from "components/dashboard/ManagerPill";
import * as theme from 'theme.js';

import './DashboardTopBar.pcss';
import {NotificationBell} from "components/dashboard/NotificationBell";
import DashboardData from "data/DashboardData";
import {handleSpacePressed} from "utils";

interface Props {
  customerName:string;
}
export const DashboardTopBar = observer((props:Props) => {
  const onOpenProfile = () => { UIState.currentPage = PageEnums.profile; }
  return (
    <div className={"dashboardTopBar noselect"}>
        <div className={'lft'}>
          <WellnessConceptsLogo variant={'favicon gradient'} />
          <h1>
            <span className={'wellness-concepts'}>Wellness Concepts</span>
            <span className={'for-customer'}> for {props.customerName}</span>
          </h1>
        </div>
        <div className={'rt'}>
          <ManagerPill />
          <NotificationBell
            notificationCount={DashboardData.collapsedNotifications.length}
            toggleNotifications={UIState.toggleNotifications}
          />
          <a style={{padding:'5px',backgroundColor:theme.SpaBlue, borderRadius:'50%'}} role={"button"} tabIndex={0} aria-label="Edit account profile"
             onClick={onOpenProfile}
             onKeyDown={(e)=>{ handleSpacePressed(e, onOpenProfile);}}
          >
            <NavAvatar user={UIState.user} variant={'medium'} style={{border:'none'}}/>
          </a>
        </div>
    </div>

  )
});
